import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AgruparLineasER } from "../Actions/ActionEstadoResultados";
import { GetKey, GetPeriodo } from "../Actions/GetContainer";
import request from "../../../Helpers/API";
import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const ERProyeccionesVentasScreen = ({ boxstate, setTituloVentas, cargarVentas, setCargarVentas, nomescenario }) => {
    // const [boxstate, setBoxState, updateBoxState] = useBoxProyecciones();
    const history = useHistory();
    const location = useLocation();
    const [primeraVez, setPrimeraVez] = useState(true);
    const [tipo_reporte, setTipoReporte] = useState("3");
    const [subtitulo, setSubtitulo] = useState("Escenario 1");

    const sucursales = location.state?.sucursales;

    const permisos = location.state;

    const idSucursalUnicos = [
        ...new Map(
            sucursales == undefined || sucursales === null || sucursales.length === 0
                ? []
                : sucursales.map((item) => [
                    item.idsucursal,
                    { idsucursal: item.idsucursal },
                ]),
        ).values(),
    ];
    // console.log(sucursales)
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [titulo, setTitulo] = useState({
        periodoinicio: "0",
        periodofin: "0",
        ejercicioinicio: "0",
        ejerciciofin: "0",
        comparacion: "",
    });
    const [state, setState] = useState({
        data: [],
    });

    const onHome = () => {
        history.push("/Finanzas/Main");
    };

    useEffect(() => {
        if (cargarVentas === true) {
            BoxClick();

        }
    }, [cargarVentas]);

    useEffect(() => {
        setPrimeraVez(false);
    }, []);

    const BoxClick = () => {
        // console.log(boxstate)
        setLoader({ ...loader, mostrar: true });
        return new Promise((res, req) => {
            if (boxstate.ejercicio == "0") {
                req("Favor de indicar el ejercicio");
                return;
            }
            if (boxstate.mesInicio == "0") {
                req("Favor de indicar el mes de inicio");
                return;
            }
            if (boxstate.mesFin == "0") {
                req("Favor de indicar el mes fin");
                return;
            }
            if (Number(boxstate.mesInicio) > Number(boxstate.mesFin)) {
                req("La fecha de inicio no puede ser mayor a la fecha fin");
                return;
            }

            if (tipo_reporte !== "3") {
                history.push("/Finanzas/EstadodeResultados", permisos);
            }

            const post = {
                ejercicio: Number(boxstate.ejercicioinicio),
                ejercicioant: Number(boxstate.ejerciciofin),
                comparar: boxstate.comparacion,
                escenario: boxstate.escenario,
                // comparar: "R",
                Periodo: GetPeriodo(boxstate.periodoinicio, boxstate.periodofin),
                departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
                sucursal:
                    primeraVez ||
                        boxstate?.pv?.sucursal === "" ||
                        boxstate?.pv?.sucursal === 0 ||
                        boxstate?.pv?.sucursal === "0" ||
                        boxstate?.pv?.sucursal === undefined ||
                        (Array.isArray(boxstate?.pv?.sucursal) &&
                            boxstate.pv.sucursal.length === 0)
                        ? GetKey(idSucursalUnicos, ["idsucursal"])
                        : GetKey(boxstate.pv.sucursal, ["idsucursal"]),
                adr: GetKey(boxstate.pv.adr, ["idadr"]),
            };
            request
                .post("ProyeccionesVenta/Obtener", post)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    var newarray = [];
                    var grupos = AgruparLineasER(result);
                    grupos.forEach((item) => {
                        newarray = [
                            ...newarray,
                            {
                                depto: item,
                                data: result.filter((x) => x.departamento == item),
                            },
                        ];
                    });
                    setState({
                        ...state,
                        data: newarray,
                    });
                    setTitulo({
                        ...titulo,
                        periodoinicio: boxstate.periodoinicio,
                        periodofin: boxstate.periodofin,
                        ejercicioinicio: boxstate.ejercicioinicio,
                        ejerciciofin: boxstate.ejerciciofin,
                        comparacion: boxstate.comparacion === "R" ? "REAL" : "PROYECTADO",
                    });
                    setTituloVentas(`ESTADO DE RESULTADOS COMPARATIVO ${SubTitulo()}`)
                    if (nomescenario) {
                        setSubtitulo(nomescenario.toUpperCase());
                    }
                    setCargarVentas(false)
                    console.log(result)
                    res("");
                })
                .catch((err) => {
                    console.log(err);
                    setLoader({ ...loader, mostrar: false });
                    req(JSON.stringify(err));
                });


        });
    };

    const imprimirexcelflujo = () => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            ejercicio: Number(boxstate.ejercicio),
            Periodo: GetPeriodo(boxstate.mesInicio, boxstate.mesFin),
            departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
            sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
            adr: GetKey(boxstate.pv.adr, ["idadr"]),
            subtitulo: SubTitulo(),
            region: boxstate.titulosucursal,
            subdepartamento: boxstate.titulodepartamento,
        };
        request
            .post("AutorizacionPG/ProyeccionVentasExcel", post)
            .then(({ documento, filename }) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((err) => {
                setLoader({ ...loader, mostrar: false });
            });
    };
    const imprimirexcelComparativo = () => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            ejercicio: Number(boxstate.ejercicio),
            Periodo: GetPeriodo(boxstate.mesInicio, boxstate.mesFin),
            departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
            sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
            adr: GetKey(boxstate.pv.adr, ["idadr"]),
            subtitulo: SubTitulo(),
            region: boxstate.titulosucursal,
            subdepartamento: boxstate.titulodepartamento,
        };
        request
            .post("RevisionProyeccion/RevisionProyeccionVentasExcel", post)
            .then(({ documento, filename }) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((err) => {
                setLoader({ ...loader, mostrar: false });
            });
    };
    const SubTitulo = () => {
        if (boxstate.ejercicioinicio === "0") return "";
        else {
            if (
                Number(boxstate.periodoinicio) === Number(boxstate.periodofin) &&
                Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin)
            ) {
                return `${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} DEL ${boxstate.ejercicioinicio}`;
            } else if (
                Number(boxstate.periodoinicio) !== Number(boxstate.periodofin) &&
                Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin)
            ) {
                return `DE ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} A ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} DEL ${boxstate.ejercicioinicio}`;
            } else if (
                Number(boxstate.periodoinicio) === Number(boxstate.periodofin) &&
                Number(boxstate.ejercicioinicio) !== Number(boxstate.ejerciciofin)
            ) {
                return `${GetMonthNameByNumber(boxstate).toUpperCase()} DEL ${boxstate.ejercicioinicio} CONTRA ${boxstate.ejerciciofin}`;
            } else {
                return `DE ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} A ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} DEL ${boxstate.ejercicioinicio} CONTRA  ${boxstate.ejerciciofin}`;
            }
        }
    };
    const getIndicadorClass = (indicador) => {
        switch (indicador) {
            case "V":
                return "indicador-verde";
            case "A":
                return "indicador-amarillo";
            case "R":
                return "indicador-rojo";
            default:
                return "";
        }
    };
    // console.log(titulo)
    return (
        <>
            <LoaderScreen loader={loader} />

            {state.data === undefined ||
                state.data === null ||
                state.data.length === 0 ? (
                <div>No existen datos para mostrar</div>
            ) : (
                <>
                    <div className="estado-resultados-header">
                        <div className="subtitulo">{subtitulo.toUpperCase()}</div>
                    </div>
                    <div
                        id="comparativa-gastos-proyeccion-tipo"
                        className="scroll-4"
                        style={{ marginRight: 10 }}
                    >
                        <table
                            className="table-informacion-estado-resultados"
                            cellSpacing={0}
                            id="tabla-sticky"
                        >
                            <thead>
                                <tr className="tr-encabezado1">
                                    <th
                                        className="bl sticky-col-h-30"
                                        style={{ minWidth: "150px" }}
                                    >
                                        CONCEPTO
                                    </th>
                                    <th className="bl sticky-col-h-30" style={{ minWidth: "80px" }}>
                                        <div>{`PROYECCION ${titulo.ejercicioinicio}`}</div>
                                    </th>
                                    <th className="sticky-col-h-30" style={{ minWidth: "20px" }}>

                                    </th>
                                    <th className="sticky-col-h-30" style={{ minWidth: "60px" }}>
                                        %
                                    </th>
                                    <th className="bl sticky-col-h-30" style={{ minWidth: "80px" }}>
                                        <div>{`${titulo.comparacion} ${titulo.ejerciciofin}`}</div>
                                    </th>
                                    <th className="sticky-col-h-30" style={{ minWidth: "80px" }}>
                                        %
                                    </th>
                                    <th className="bl sticky-col-h-30" style={{ minWidth: "80px" }}>
                                        <div>DIFERENCIA</div>
                                    </th>
                                    <th className="br sticky-col-h-30" style={{ minWidth: "80px" }}>
                                        %
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.map((item) => (
                                    <>
                                        <tr>
                                            <td className="bl br depto-title" colSpan={8}>
                                                {item.depto}
                                            </td>
                                        </tr>
                                        {item.data.map((obj) => (
                                            <tr>
                                                <td className={`bl ${obj.clase}`}>{obj.concepto}</td>
                                                <td className={`bl ta-right ${obj.clase} `}>
                                                    {FormatMoney(obj.importe, 2)}
                                                </td>
                                                <td className="ta-center" >
                                                    <span className={`indicador ${getIndicadorClass(obj.indicador)}`}></span>
                                                </td>
                                                <td className={`ta-right ${obj.clase}  pr-5`}>
                                                    {FormatMoney(obj.por, 2)} %
                                                </td>
                                                <td className={`bl ta-right ${obj.clase} `}>
                                                    {FormatMoney(obj.proyimporte, 2)}
                                                </td>
                                                <td className={`ta-right ${obj.clase} pr-5 `}>
                                                    {FormatMoney(obj.proypor, 2)} %
                                                </td>
                                                <td className={`bl ta-right ${obj.clase} `}>
                                                    {FormatMoney(obj.diffimporte, 2)}
                                                </td>
                                                <td className={`br ta-right ${obj.clase} pr-5 `}>
                                                    {FormatMoney(obj.diffpor, 2)} %{" "}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr style={{ height: 20 }}></tr>
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

        </>
    );
};
